<template>
  <div class="case-header-container">
    <div class="header-wrap">
      <img :src="caseInfo.image" alt="case image" />
      <div class="name">{{ caseInfo.name }}</div>
    </div>
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";

export default {
  mixins: [responsiveMixin],
  components: {},
  data() {
    return {};
  },
  props: {
    caseInfo: {
      type: Object,
      default: () => { }
    }
  },
  mounted() { },
  beforeDestroy() { },
  methods: {},
  watch: {}
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
